import {
  SEND_PRESET, // this sends the preset to the device

  SET_PRESET_GAIN,
  SET_ZONE_SPLIT_POINT,
  SET_ZONE_CHANNEL,
  SET_ZONE_CURVE,
  DECREMENT_LOWNOTE,
  INCREMENT_LOWNOTE,
  DECREMENT_OCTAVE,
  INCREMENT_OCTAVE,
  SET_GAP_CAPS,
  SET_GAP_CAPS_CURVE,
  SET_GAP_CAPS_CHANNEL,
  TOGGLE_GAP_CAPS,
  SET_BUTTON_PROGRAM_CHANGE,
  SET_BUTTON_BANK_SELECT,
  SET_BUTTON_NOTE,
  SET_BUTTON_CC,
  SET_BUTTON_CHANNEL,
  SET_FADER_MODE,
  SET_FADER_CC,
  SET_FADER_CHANNEL,
  SET_PEDAL_MODE,
  SET_PEDAL_CC,
  SET_PEDAL_CHANNEL,
  SELECT_PLAY_MODE,
  SET_MIDI_NOTE_LENGTH,
  SET_DAMP_THRESHOLD
} from '../actions/actionTypes'

export default [
  SEND_PRESET,

  SET_PRESET_GAIN,
  SET_ZONE_SPLIT_POINT,
  SET_ZONE_CHANNEL,
  SET_ZONE_CURVE,
  DECREMENT_LOWNOTE,
  INCREMENT_LOWNOTE,
  DECREMENT_OCTAVE,
  INCREMENT_OCTAVE,
  SET_GAP_CAPS,
  SET_GAP_CAPS_CURVE,
  SET_GAP_CAPS_CHANNEL,
  TOGGLE_GAP_CAPS,
  SET_BUTTON_PROGRAM_CHANGE,
  SET_BUTTON_BANK_SELECT,
  SET_BUTTON_NOTE,
  SET_BUTTON_CC,
  SET_BUTTON_CHANNEL,
  SET_FADER_MODE,
  SET_FADER_CC,
  SET_FADER_CHANNEL,
  SET_PEDAL_MODE,
  SET_PEDAL_CC,
  SET_PEDAL_CHANNEL,
  SELECT_PLAY_MODE,
  SET_MIDI_NOTE_LENGTH,
  SET_DAMP_THRESHOLD
]
